import Swal from 'sweetalert2';

export default class Alert {
    constructor() {
        this.errors = {};
    }

    fail(message = "", title = "Error!") {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
            icon: 'error',
            title: title,
            text: message
        })
    }

    success(message = "") {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
            icon: 'success',
            title: message
        })
    }

    dialog(message = "", confText = "", cancelText = "", text = "") {
        return new Promise((resolve, reject) => {
            Swal.fire({
                title: message,
                text: text,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#e02424',
                cancelButtonColor: '#e5af0b',
                confirmButtonText: confText,
                cancelButtonText: cancelText
            }).then((result) => {
                if (result.value) {
                    resolve(result);
                }
            })
        })
    }

    promptLanguagePreference(defaultLocale = 'en', settingsUrl = '/settings/language') {
        // Get language name from languages.json
        const languages = require('../assets/languages.json').values;
        const language = languages.find(lang => lang.code === defaultLocale);
        
        // If language is not supported, default to English
        if (!language) {
            localStorage.setItem('preferred_language', 'en');
            const domain = window.location.hostname;
            document.cookie = `preferred_language=en;path=/;domain=${domain};max-age=31536000`;
            console.log('Cookies set:', document.cookie);
            
            window.api.call('post', 'user-settings/language', {
                ui_language: 'en',
                subtitle_language: 'en',
                content_language: 'en'
            })
            .then(response => {
                this.success('Your language has been set to English.');
                window.location.reload();
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    this.success('Your language preference has been saved.');
                } else {
                    localStorage.removeItem('preferred_language');
                    document.cookie = 'preferred_language=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
                    this.fail('', error.response?.data?.message || 'Failed to update language preferences');
                }
            });
            return;
        }

        localStorage.setItem('preferred_language', defaultLocale);
        const domain = window.location.hostname;
        document.cookie = `preferred_language=${defaultLocale};path=/;domain=${domain};max-age=31536000`;
        console.log('Cookies set:', document.cookie);

        Swal.fire({
            title: 'Set Your Language',
            text: `We detected your language as ${language.name}. Do you want to use this as your default language?`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Yes, Set as Default',
            cancelButtonText: 'Go to Settings',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#007bff',
        }).then((result) => {
            if (result.isConfirmed) {
                window.api.call('post', 'user-settings/language', {
                    ui_language: defaultLocale,
                    subtitle_language: 'en',
                    content_language: 'en'
                })
                .then(response => {
                    this.success(`Your language has been set to ${language.name}.`);
                    window.location.reload();
                })
                .catch(error => {
                    if (error.response?.status === 401) {
                        this.success(`Your language preference has been saved.`);
                    } else {
                        localStorage.removeItem('preferred_language');
                        document.cookie = 'preferred_language=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
                        this.fail('', error.response?.data?.message || 'Failed to update language preferences');
                    }
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                window.location.href = settingsUrl;
            }
        });
    }
}
